export function findMailboxByLabel(mailboxes, label) {
  const fullMailbox = mailboxes.find(mailbox => mailbox.label === label)
  if (!fullMailbox) return null
  return fullMailbox
}

// just because 'All Inboxes' is enabled does not mean we always show it in left nav
// we only show 'All Inboxes' if the user has more than 1 mailbox
export const showAllInboxesMailboxInLeftNav = (
  prefersAllMailboxesSectionVisible,
  mailboxes
) => {
  return prefersAllMailboxesSectionVisible && (mailboxes?.length || 0) > 1
}
